import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DocumentShouldNotHaveMoreThanOneSelectedJpkVatProcedureError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.document-should-be-one-selected-jpk-vat-procedure-error');
    }
}
